import { ThumbnailUrl } from '../models'
import NoImage from 'src/Resources/Images/shop/NoImage.png'
import { Media } from '../models/product.model'

export interface MediaFiles {
  downloads: Media[]
  images: Media[]
}

/*
 * This function checks on the given array if there is an image with the given width size and return the url.
 * If there is no image found on the array it returns a default image.
 */
export const getImageUrlBySize = (images: ThumbnailUrl[] | undefined, widthSize: number): string => {
  if (images && images.length > 0) {
    const matchingImage = images.find(image => image.width === widthSize)
    if (matchingImage) {
      return matchingImage.url
    }
  }

  return NoImage
}
